export enum EventType {
  USER_CHANGE = "user-change",
  VOTE_CHANGE = "vote-change",
  TIMER_CHANGE = "timer-change",
  TASK_LIST_UPDATE = "task-list-update",
  TASK_ADD = "task-add",
  VOTE_REVEAL = "vote-reveal",
  NEW_VOTING = "new-voting",
  SIO_CONNECT_ERROR = "connect_error",
  SIO_RECONNECT_FAILED = "reconnect_failed",
  GAME_SUMMARY = "game-summary",
}
